<script setup>
import {
    computed, ref,
} from 'vue';

import NavHorizontalOverflow from './NavHorizontalOverflow';
import {
    useNotificationsStore,
} from '../../../stores/notifications-store';

const notifications = useNotificationsStore();

const items = computed(() => ([
    {
        id: 'dashboard',
        name: 'Übersicht',
        tag: 'router-link',
        to: { name: 'page-dashboard' },
        trackingName: 'Dashboard',
    },
    {
        id: 'cv',
        name: 'Lebenslauf',
        tag: 'router-link',
        to: { name: 'page-cv' },
        trackingName: 'Profile',
    },
    {
        id: 'stats',
        name: 'Aufrufe',
        notification: notifications.cv && {
            label: 'Dein Lebenslauf wurde aufgerufen',
        },
        tag: 'router-link',
        to: { name: 'page-views' },
        trackingName: 'Profile Views',
    },
    {
        id: 'messages',
        name: 'Nachrichten',
        notification: notifications.messages && {
            label: 'Du hast neue Nachrichten',
        },
        tag: 'router-link',
        to: { name: 'page-conversations' },
        trackingName: 'Messages',
    },
    {
        id: 'applications',
        name: 'Bewerbungen',
        tag: 'router-link',
        to: { name: 'page-applications' },
        trackingName: 'Applications',
    },
    /*
    {
        id: 'motivation-letter',
        name: 'Bewerbungsschreiben',
        tag: 'router-link',
        to: { name: 'page-motivation-letters' },
    },
     */
]));

const nav = ref(null);

const emit = defineEmits(['click-link']);
</script>

<template>
    <NavHorizontalOverflow
        ref="nav"
        :items="items"
        is-centered
        is-sticky
        data-qa="sub navigation"
        @click-link="emit('click-link', $event)"
    />
</template>
